import { supabase } from './supabase'

const API = import.meta.env.VITE_API_URL || ''

const seen = new Set()

// Evita reportar el mismo error 100 veces en un segundo.
function isDuplicate(message) {
  const key = message.slice(0, 200)
  if (seen.has(key)) return true
  seen.add(key)
  setTimeout(() => seen.delete(key), 30_000)
  return false
}

export async function reportError({ severity = 'error', message, stack, source = 'frontend', extra } = {}) {
  if (!message) return
  if (isDuplicate(message)) return
  if (!API) return
  try {
    const headers = { 'Content-Type': 'application/json' }
    try {
      const { data } = await supabase.auth.getSession()
      const token = data?.session?.access_token
      if (token) headers.Authorization = `Bearer ${token}`
    } catch {}
    fetch(`${API}/api/log-error`, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        source,
        severity,
        message: String(message).slice(0, 2000),
        stack: stack ? String(stack).slice(0, 8000) : null,
        url: typeof window !== 'undefined' ? window.location.href : null,
        extra,
      }),
    }).catch(() => {})
  } catch {}
}

export function installErrorHandlers() {
  if (typeof window === 'undefined') return
  window.addEventListener('error', (e) => {
    if (e.message && !/ResizeObserver/.test(e.message)) {
      reportError({ message: e.message, stack: e.error?.stack, source: 'frontend-window' })
    }
  })
  window.addEventListener('unhandledrejection', (e) => {
    const reason = e.reason
    const message = reason?.message || String(reason)
    reportError({ message, stack: reason?.stack, source: 'frontend-promise' })
  })
}
